module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    class: {
      'card_viewed': _vm.viewed
    }
  }, [_c('p', {
    staticClass: "card__date"
  }, [_vm._v(_vm._s(_vm.date))]), _c('div', {
    staticClass: "card__main"
  }, [_c('Icon', {
    staticClass: "card__icon",
    attrs: {
      "type": _vm.viewed ? 'viewed' : 'unread',
      "size": "big"
    }
  }), _c('div', {
    staticClass: "card__body"
  }, [_c('h2', {
    staticClass: "card__title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('Accordion', {
    attrs: {
      "opened": _vm.longMessage ? _vm.opened : true,
      "initHeight": _vm.longMessage ? '50px' : '0'
    }
  }, [_c('div', {
    staticClass: "card__text",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]), _c('div', {
    staticClass: "card__footer"
  }, [(_vm.longMessage) ? _c('button', {
    staticClass: "card__action",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._v(_vm._s(_vm.toggleText))]) : _vm._e(), (!_vm.viewed) ? _c('button', {
    staticClass: "card__action",
    on: {
      "click": _vm.readNotification
    }
  }, [_vm._v("отметить как прочитанное")]) : _vm._e(), (!_vm.longMessage && _vm.viewed) ? _c('div', {
    staticClass: "card__readed"
  }, [_vm._v("прочитано")]) : _vm._e()])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c26a500c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/notification/blocks/card/Card.vue
// module id = 98f5c1bfa00adc333089
// module chunks = 0